import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import css from './style.pcss';
import getTranslations from './translations.js';
import dayjs from "dayjs";
import logo from "./images/logo.svg";
var MIN_TEMPERATURE = 0;
var MAX_TEMPERATURE = 45;
var MIN_HUMIDITY = 0;
var MAX_HUMIDITY = 100;
var COLOR_SCALES = ["#4F9529", "#FFFF54", "#EA3323"];
var RTLCityClim = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLCityClim, _LitElement);
  function RTLCityClim() {
    var _this;
    _classCallCheck(this, RTLCityClim);
    _this = _callSuper(this, RTLCityClim);
    _this.minTemp = localStorage.getItem("clim-min-temperature") || 5;
    _this.maxTemp = localStorage.getItem("clim-max-temperature") || 20;
    _this.minHumidity = localStorage.getItem("clim-min-humidity") || 5;
    _this.maxHumidity = localStorage.getItem("clim-max-humidity") || 20;
    _this.currentTimestampIndex = 0;
    _this.translations = {};
    _this.timestamps = [0];
    return _this;
  }
  _createClass(RTLCityClim, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLCityClim.prototype), "connectedCallback", this).call(this);
      this.language = this.language || "lu";
      this.translations = getTranslations(this.language);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this2 = this;
      window.addEventListener('message', function (event) {
        // console.log(event.data.eventId)
        if (event.data.eventId === 'meteologix.colorizeReady') {
          // Map ready to receive colorize input
          _this2.updateMap();
        }
        if (event.data.eventId === 'meteologix.timestamps') {
          _this2.timestamps = event.data.data.timestamps;
          _this2.currentTimestampIndex = 0;
          // console.log(this.timestamps);
          _this2.updateMap();
        }
      });
      this._fillColor();

      // setTimeout(() => { //TODO: amfong sollten ma ob hieren callback warden, mee deen kennt net?
      //     this.updateMap();
      // }, 1000);
    }
  }, {
    key: "updateMap",
    value: function updateMap() {
      var iframe = this.renderRoot.getElementById('sensation-map-iframe');
      var tMin = Number(this.minTemp);
      var tMax = Number(this.maxTemp);
      var minTemp = tMin < tMax ? tMin : tMax;
      var maxTemp = tMax > tMin ? tMax : tMin;

      // let minHumidity = this.minHumidity < this.maxHumidity ? this.minHumidity : this.maxHumidity;
      // let maxHumidity = this.maxHumidity > this.minHumidity ? this.maxHumidity : this.minHumidity;

      var messageData = {
        eventId: 'meteologix.colorize',
        data: {
          minHeatIndex: minTemp,
          maxHeatIndex: maxTemp,
          // minHumidity: minHumidity,
          // maxHumidity: maxHumidity,
          scale: COLOR_SCALES,
          timestamp: this.timestamps[this.currentTimestampIndex]
        }
      };

      // console.log("messageData", messageData)
      iframe.contentWindow.postMessage(messageData, 'https://meteologix.com');
    }
  }, {
    key: "changeTempSlider",
    value: function changeTempSlider(type, value) {
      // console.log(type, value);
      if (type === "min") {
        this.minTemp = value;
      } else {
        this.maxTemp = value;
      }
      localStorage.setItem("clim-min-temperature", this.minTemp);
      localStorage.setItem("clim-max-temperature", this.maxTemp);
      this.updateMap();
      this._fillColor();
    }
  }, {
    key: "changeHumiditySlider",
    value: function changeHumiditySlider(type, value) {
      // console.log(type, value);
      if (type === "min") {
        this.minHumidity = value;
      } else {
        this.maxHumidity = value;
      }
      localStorage.setItem("clim-min-humidity", this.minHumidity);
      localStorage.setItem("clim-max-humidity", this.maxHumidity);
      this.updateMap();
    }
  }, {
    key: "_setPlayState",
    value: function _setPlayState(state) {
      if (!this.state) {
        this._startAnimation();
      } else {
        this._stopAnimation();
      }
    }
  }, {
    key: "_getIndex",
    value: function _getIndex() {
      this.currentTimestampIndex >= this.timestamps.length - 1 ? this.currentTimestampIndex = 0 : this.currentTimestampIndex = this.currentTimestampIndex + 1;
      var slider = this.shadowRoot.querySelector('.rtl-radar-nav__slider');
      slider.value = this.currentTimestampIndex;
      this.updateMap();
      //console.log(this.currentIndex);
    }
  }, {
    key: "_startAnimation",
    value: function _startAnimation() {
      this.animation = setInterval(this._getIndex.bind(this), 200);
      this.state = true;
      var btn = this.shadowRoot.querySelector('.rtl-radar-nav__btn div');
      if (btn) btn.classList.add('paused');
    }
  }, {
    key: "_stopAnimation",
    value: function _stopAnimation() {
      clearInterval(this.animation);
      this.state = false;
      var btn = this.shadowRoot.querySelector('.rtl-radar-nav__btn div');
      if (btn) btn.classList.remove('paused');
    }
  }, {
    key: "_handleSlider",
    value: function _handleSlider(e) {
      this._stopAnimation();
      this.currentTimestampIndex = Number(e.target.value);
      this.updateMap();
    }
  }, {
    key: "_fillColor",
    value: function _fillColor() {
      var tMin = Number(this.minTemp);
      var tMax = Number(this.maxTemp);
      var minTemp = tMin < tMax ? tMin : tMax;
      var maxTemp = tMax > tMin ? tMax : tMin;
      var minTempPercentage = 100 / MAX_TEMPERATURE * minTemp;
      var maxTempPercentage = 100 / MAX_TEMPERATURE * maxTemp;
      var sliderTrack = this.shadowRoot.querySelector(".slider-track");

      // sliderTrack.style.background = `linear-gradient(to right, #D8DADD ${minTempPercentage}% , #787F88 ${minTempPercentage}% , #787F88 ${maxTempPercentage}%, #D8DADD ${maxTempPercentage}%)`;
      sliderTrack.style.background = `linear-gradient(to right, #4F9529 ${minTempPercentage}% , #FFFF54 ${minTempPercentage}% , #FFFF54 ${maxTempPercentage}%, #EA3323 ${maxTempPercentage}%)`;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var minTempPercentage = 100 / MAX_TEMPERATURE * this.minTemp;
      var maxTempPercentage = 100 / MAX_TEMPERATURE * this.maxTemp;

      // let minHumidityPercentage = 100 / MAX_HUMIDITY * this.minHumidity;
      // let maxHumidityPercentage = 100 / MAX_HUMIDITY * this.maxHumidity;

      var translations = this.translations;
      var invertedClass = "";
      if (Number(this.minTemp) > Number(this.maxTemp)) invertedClass = "inverted";
      return html(_t || (_t = _`
            <style>${0}</style>
            <div class="cityclim__container">
                <div class="cityclim__iframe-container">
                    ${0}
                    <div class="cityclim__text">
                        ${0}
                    </div>
                    <iframe class="cityclim__iframe" src="https://meteologix.com/citizen-weather-sensation-engine/map?apiKey=ZNLnWTNHfeWiUIu2E69Xt82LOr3NlK1l" id="sensation-map-iframe"></iframe>
                    <div class="cityclim__color-container">
                        <div class="cityclim__color-box-container">
                            <div class="cityclim__color-box" style=${0}>&nbsp;</div>
                            <span>${0}</span>
                        </div>
                        <div class="cityclim__color-box-container">
                            <div class="cityclim__color-box" style=${0}>&nbsp;</div>
                            <span>${0}</span>
                        </div>
                        <div class="cityclim__color-box-container">
                            <div class="cityclim__color-box" style=${0} >&nbsp;</div>
                            <span>${0}</span>
                        </div>
                    </div>

                </div>

                <div class="rtl-radar-nav">
                    <div class="rtl-radar-nav__btn" @click=${0}>
                        <div></div>
                    </div>
                    <div class="rtl-radar-nav__slidercontainer">
                        <input type="range" min="0" max="${0}" @input="${0}" value="0" class="rtl-radar-nav__slider" id="animrange">
                    </div>
                    <div class="rtl-radar-nav__time">${0}</div>
                </div>


                <div class="cityclim__slider-container" style="flex: 1;">
                    <h2 class="cityclim__slider-title">${0}</h2>
                    <div class="cityclim__slider">
                        <div class="cityclim__slider-content">
                            <div class="value-bubble" style=${0}>${0} °C</div>
                            <div class="value-bubble" style=${0}>${0} °C</div>

                            <div class="multi-ranges ${0}">
                                <div class="slider-track"></div>
                                <input type="range" id="range1" class="multi-range" min="${0}" max="${0}" value=${0} step="1" @input=${0}>
                                <input type="range" id="range2" class="multi-range" min="${0}" max="${0}" value=${0} step="1" @input=${0}>
                            </div>
                        </div>
                        <div class="cityclim__slider-legend-container">
                            <div class="cityclim__slider-legend cityclim__slider-legend--min">${0} °C</div>
                            <div class="cityclim__slider-legend cityclim__slider-legend--max" style="text-align: right">${0} °C</div>
                        </div>
                    </div>
                </div>

                <div class="cityclim__slider-description">
                    ${0}
                </div>
                <div class="logo-container">
                    Source: <a href="https://www.cityclim.eu/" target="_blank"><img width="50px" src=${0} /></a>
                </div>
            </div>`), css, !this.notitle ? html(_t2 || (_t2 = _`<h1 class="cityclim__title">${0}</h1>`), translations.individual_map_title) : "", unsafeHTML(translations.map_description), `background-color: ${COLOR_SCALES[2]}; display: inline-block; min-width:50px`, translations.not_recommended, `background-color: ${COLOR_SCALES[1]}; display: inline-block; min-width:50px`, translations.acceptable, `background-color: ${COLOR_SCALES[0]}; display: inline-block; min-width:50px`, translations.comfort, this._setPlayState, this.timestamps.length - 1, this._handleSlider, dayjs.unix(this.timestamps[this.currentTimestampIndex]).format("DD.MM.YYYY - HH:mm"), translations.conform_temperature_title, `bottom: 12px; left: calc(${minTempPercentage}% + (${-10 - minTempPercentage * 0.15}px))`, this.minTemp, `bottom: 12px; left: calc(${maxTempPercentage}% + (${-60 - maxTempPercentage * 0.15}px))`, this.maxTemp, invertedClass, MIN_TEMPERATURE, MAX_TEMPERATURE, this.minTemp, function (e) {
        return _this3.changeTempSlider("min", e.target.value);
      }, MIN_TEMPERATURE, MAX_TEMPERATURE, this.maxTemp, function (e) {
        return _this3.changeTempSlider("max", e.target.value);
      }, MIN_TEMPERATURE, MAX_TEMPERATURE, translations.calibration_description, logo);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        isOpen: {
          type: Boolean
        },
        minTemp: {
          type: String
        },
        maxTemp: {
          type: String
        },
        language: {
          type: String
        },
        minHumidity: {
          type: String
        },
        maxHumidity: {
          type: String
        },
        timestamps: {
          type: Array
        },
        currentTimestampIndex: {
          type: Number
        },
        state: {
          type: Boolean
        },
        notitle: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLCityClim;
}(LitElement);
export { RTLCityClim as default };
window.customElements.define('rtl-city-clim', RTLCityClim);